/*
 * タイムセール（旧PREMIUM SALE）ラインナップ表示の鮮度確保
 * 目的: エッジ/ブラウザキャッシュで特売コーナーが旧ラインナップのまま表示される事象への対策。
 *       キャッシュを消すのではなく、当日JST日付をキーにセクションを取り直して差し替える（キャッシュ回避）。
 *       260829改修でセールは週替わり（月曜0時切替）になったが、日付キーの日次更新は
 *       無害なキャッシュ回避として維持する（切替は月曜0時跨ぎの検知で反映される）。
 *   ① 読込時: 日付キー付きURLでセクションを再取得し、商品が変わっていれば差し替え。
 *   ② 0時跨ぎ: JST日付の変化を検知して再取得（cron遅延を考慮し数回リトライ）。
 * 注文データには関与しない（表示の上書きのみ）。JS無効環境ではサーバ初期描画のまま動作。
 */
(function () {
  if (window.__premiumSaleRefreshInit) return;
  window.__premiumSaleRefreshInit = true;

  // JSTの当日日付を YYYYMMDD で返す（クライアントTZに依存しない）
  function jstYmd() {
    var now = new Date();
    var jst = new Date(now.getTime() + (now.getTimezoneOffset() + 540) * 60000);
    var m = ('0' + (jst.getMonth() + 1)).slice(-2);
    var d = ('0' + jst.getDate()).slice(-2);
    return '' + jst.getFullYear() + m + d;
  }

  // 対象セクション内の商品ハンドル集合（＝表示ラインナップの署名）
  function signature(root) {
    if (!root) return '';
    var handles = {};
    root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (m) handles[m[1]] = true;
    });
    return Object.keys(handles).sort().join(',');
  }

  // セクションを日付キー付きで取得し、ラインナップが変わっていれば差し替える
  function refresh(section) {
    var id = section.getAttribute('data-id');
    if (!id) return Promise.resolve(false);
    var url = location.pathname + '?section_id=' + encodeURIComponent(id) + '&_ps=' + jstYmd();
    return fetch(url, { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return false;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-ps-refresh]');
        if (!fresh) return false;
        var freshSig = signature(fresh);
        if (!freshSig) return false;                       // 空取得時は既存表示を保持
        if (freshSig === signature(section)) return false; // 変化なし＝差し替え不要
        // スワップ後に隠れないよう、スクロールアニメを無効化（テーマ既存の作法に準拠）
        fresh.querySelectorAll('.scroll-trigger').forEach(function (el) {
          el.classList.add('scroll-trigger--cancel');
        });
        section.innerHTML = fresh.innerHTML;               // カスタム要素の再初期化でSwiper/quick-add復帰
        // 割引率ソート（premium-sale-sort.js）へ再ソートを通知
        section.dispatchEvent(new CustomEvent('ps:section-refreshed', { bubbles: true }));
        return true;
      })
      .catch(function () { return false; });
  }

  // 0時跨ぎ後、cron遅延を見越して数回リトライ（切替が届き次第反映されれば以降はno-op）
  function refreshWithRetry(section) {
    [0, 60000, 180000, 300000, 600000].forEach(function (ms) {
      setTimeout(function () { refresh(section); }, ms);
    });
  }

  function start() {
    var section = document.querySelector('[data-ps-refresh]');
    if (!section) return;
    refresh(section);                                       // ① 読込時の鮮度確保
    var currentDay = jstYmd();
    setInterval(function () {                               // ② 0時跨ぎ検知
      var d = jstYmd();
      if (d !== currentDay) { currentDay = d; refreshWithRetry(section); }
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
